package er.prateek.crossly.persistence

import com.russhwolf.settings.Settings
import er.prateek.crossly.share.OutboundShare
import kotlinx.serialization.builtins.ListSerializer
import kotlinx.serialization.json.Json

private val json = Json { ignoreUnknownKeys = true }
private const val KEY_OUTBOUND = "outbound_shares"
private const val MAX_ENTRIES = 50

class SettingsOutboundShareStore(
    private val settings: Settings,
) : OutboundShareStore {
    override fun add(entry: OutboundShare) {
        val next = (all() + entry)
            .distinctBy { it.token }
            .takeLast(MAX_ENTRIES)
        settings.putString(KEY_OUTBOUND, json.encodeToString(ListSerializer(OutboundShare.serializer()), next))
    }

    override fun containsToken(token: String): Boolean = all().any { it.token == token }

    override fun all(): List<OutboundShare> {
        val raw = settings.getStringOrNull(KEY_OUTBOUND) ?: return emptyList()
        return runCatching {
            json.decodeFromString(ListSerializer(OutboundShare.serializer()), raw)
        }.getOrDefault(emptyList())
    }
}
